import useTranslate from 'app/i18n/useTranslate';

const useConstants = () => {
    const t = useTranslate('onboardingOrganizationCreationPage');

    return {
        ORGANIZATION_NAME_BODY_TEXT: t('organizationNameBodyText'),
        ORGANIZATION_NAME_FOOTER_TEXT: t('organizationNameFooterText'),
        ORGANIZATION_NAME_PLACEHOLDER: t('organizationNamePlaceholder')
    };
};

export default useConstants;
